import {
  CreditCard,
  Home,
  LayoutList,
  ShoppingBag,
  Trophy,
} from 'lucide-react';
import React, { type JSX, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface NavItem {
  label: string;
  href: string;
  icon: JSX.Element;
}

const ManagerBottomNavigationBar: React.FC = () => {
  const [activeItem, setActiveItem] = useState<string | null>(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navItems: NavItem[] = [
    {
      label: t('manager.navigation.home'),
      href: '/manager/home',
      icon: <Home />,
    },
    {
      label: t('manager.navigation.tasks'),
      href: '/manager/tasks',
      icon: <LayoutList />,
    },
    {
      label: t('manager.navigation.goals'),
      href: '/manager/goals',
      icon: <Trophy />,
    },
    {
      label: t('manager.navigation.cards'),
      href: '/manager/cards',
      icon: <CreditCard />,
    },
    {
      label: t('manager.navigation.shop'),
      href: '/manager/shop',
      icon: <ShoppingBag />,
    },
  ];

  const handleTouchStart = (label: string) => {
    setActiveItem(label);
  };

  const handleTouchEnd = () => {
    setTimeout(() => setActiveItem(null), 150);
  };

  const handleNavigation = (href: string) => {
    // Pass state to indicate navigation from bottom menu for tasks page
    if (href === '/manager/tasks') {
      navigate(href, { state: { from: 'bottom-navigation' } });
    } else {
      navigate(href);
    }
  };

  return (
    <Navbar fixed="bottom" bg="white" className="border-top py-2">
      <Container fluid>
        <Nav className="w-100 justify-content-around">
          {navItems.map(item => (
            <Nav.Item key={item.label} className="text-center">
              <Nav.Link
                as="button"
                onClick={() => handleNavigation(item.href)}
                className={`d-flex flex-column align-items-center text-decoration-none border-0 bg-transparent ${
                  activeItem === item.label ? 'animate-tap' : ''
                }`}
                onMouseDown={() => handleTouchStart(item.label)}
                onMouseUp={handleTouchEnd}
                onTouchStart={() => handleTouchStart(item.label)}
                onTouchEnd={handleTouchEnd}
                style={{
                  transition:
                    'transform 0.1s ease-in-out, opacity 0.1s ease-in-out',
                  transform:
                    activeItem === item.label ? 'scale(0.7)' : 'scale(1)',
                  opacity: activeItem === item.label ? 0.7 : 1,
                  color:
                    window.location.pathname === item.href
                      ? '#111418'
                      : '#60758a',
                }}
              >
                <div className="d-flex align-items-center justify-content-center mb-1">
                  {React.cloneElement(item.icon, { size: 24 })}
                </div>
                <span className="fw-medium" style={{ fontSize: '12px' }}>
                  {item.label}
                </span>
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </Container>
    </Navbar>
  );
};

export default ManagerBottomNavigationBar;
